import React from "react";
import "../../assets/styles/components/select.scss";

interface Props {
  placeholder?: string;
  title?: string;
  className?: string;
  option: {
    value: string;
    name: string;
  }[];
  value?: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

// export type Props = {
//   placeholder?: string;
//   title?: string;
//   className?: string;
//   option: {
//     value: string;
//     name: string;
//   }[];
//   onChange?: (value?: string) => void;
//   onChange?: (event: React.ChangeEvent<{ value: unknown }>) => void;
// }

// export type SelectFieldProps = {
//   placeholder?: string;
//   title?: string;
//   className?: string;
//   option: {
//     value: string;
//     name: string;
//   }[];
//   onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
//   // onSearch?: (value?: string) => void;
//   // onChange?: (value?: string) => void;
//   // onVisibleChange?: (b: boolean) => void;
//   // className?: string;
//   // placeholder?: string;
//   // options: AutoCompleteProps['options'];
//   // defaultVisible?: boolean;
//   // visible?: boolean;
//   // defaultValue?: string;
//   // value?: string;
// };

const SelectField: React.FC<Props> = ({
  placeholder,
  onChange,
  option,
  title,
  className,
  value,
  disabled = false,
  ...rest
}) => {
  let attributes = Object.assign({});
  attributes.className = `select-field ${className || ""}`;
  return (
    <div {...attributes}>
      <div className="title-input">{title}</div>

      <select id="select" onChange={onChange} value={value} disabled={disabled}>
        <option value="">
        </option>
        {option.map((option, index) => (
          <option value={option.value} key={index}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};
export default SelectField;
